import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './common/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ApplicationType, WelcomeService } from './common/services/welcome.service';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

import { ImpersonateService } from './common/services/impersonate.service';

@Component({
  selector: 'app-impersonate',
  template: `
    <div>
      <header class="appHeader navi">
        <a href="/" class="logo white"></a>
      </header>

      <div class="frontEndNav">
        <div class="band appTitle outNav secondaryBG">
          <div class="wrap">
            <h3 class="">Welcome to SimpleCitizen</h3>
          </div>
        </div>

        <div class="navScroll">
          <div class="navTabs navi whiteT opat25">
            <span class="whiteT navTab is-active">
              <i aria-hidden="true" class="fa fa-check-square-o"></i> My Application
            </span>
            <span class="whiteT navTab"> <i aria-hidden="true" class="fa fa-user"></i> My Account </span>
          </div>

          <nav class="appNav navi whiteT">
            <div class="band appTitle inNav marBot40">
              <div class="wrap">
                <h3 class="">Welcome to SimpleCitizen</h3>
              </div>
            </div>
          </nav>
        </div>
      </div>

      <div class="mainBody">
        <article class="band">
          <div class="wrap">
            <section class="pageTitle tAlignLeft">
              <h1 class="primaryT w300">Impersonating</h1>
            </section>
          </div>
        </article>
      </div>
    </div>
  `,
  standalone: true
})
export class ImpersonateComponent implements OnInit, OnDestroy {
  private alive: boolean;

  constructor(private impersonate: ImpersonateService) {}

  ngOnInit(): void {
    this.alive = true;
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
